module.exports = __webpack_public_path__ + "img/inge-v6-6.185a204f.png";